var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown-component" },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-container",
          class: { open: _vm.open },
          on: {
            mouseup: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm.showClose
            ? _c(
                "button",
                {
                  staticClass: "close-button",
                  attrs: { type: "button", "aria-label": "Close Dropdown" },
                  on: { click: _vm.close }
                },
                [_c("i", { staticClass: "icon-close" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("option-header"),
          _vm._v(" "),
          _c("div", { staticClass: "scroll-container" }, [
            _c("ul", { staticClass: "dropdown" }, [_vm._t("option")], 2)
          ]),
          _vm._v(" "),
          _vm._t("option-footer")
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }